import { render, staticRenderFns } from "./HumanCapitalAcquisitionRateInput.vue?vue&type=template&id=6e0230c5&scoped=true&"
import script from "./HumanCapitalAcquisitionRateInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAcquisitionRateInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalAcquisitionRateInput.vue?vue&type=style&index=0&id=6e0230c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0230c5",
  null
  
)

export default component.exports